import Flex from '../ui/Flex';
import Grid from '../ui/Grid';
import PageCategory from './PageCategory';
import PageHeaderRoot from './PageHeaderRoot';
import PageMedia from './PageMedia';
import PageMeta from './PageMeta';
import PageSocials from './PageSocials';

const PageHeaderArticle = () => {
  return (
    <PageHeaderRoot
      variant="article"
      // maxWidth="lg"
      GridColProps={{ offsetMd: 2, md: 8 }}
      beforeCol={
        <Grid.Col offsetMd={2} md={8}>
          <PageCategory />
        </Grid.Col>
      }
      afterCol={
        <Grid.Col offsetMd={2} md={8}>
          <Flex direction="row" justifyContent="between">
            <PageMeta />
            <PageSocials />
          </Flex>
        </Grid.Col>
      }
      afterContainer={<PageMedia pageFeatureImage={{ priority: true }} />}
    />
  );
};

export default PageHeaderArticle;
